export const REFRESH_WALLET_DETAIL_EVENT = Symbol()

export const CHANGE_RECEIVE_ADDRESS_EVENT = Symbol()

export const REFRESH_RECEIVE_ADDRESS_EVENT = Symbol()

export const REFRESH_SWEEP_RULE_LIST = Symbol()

export const NO_PERMISSION_EVENT = Symbol()
